import { combineReducers } from 'redux';
import registersReducer from '../modules/registers/reducers';

const rootReducer = combineReducers({
  register: registersReducer,
});

export default rootReducer;
